/* Trainline widget */

window.addEventListener('load', function () {
	var trainlineWidgets = document.querySelectorAll('[data-trainline-widget]');
	for (var i = 0; i < trainlineWidgets.length; i++) {
		let trainlineWidget = trainlineWidgets[i];
		trainlineWidget.classList.remove('is-active');

		let trainlineWidgetSource = trainlineWidget.dataset.trainlineWidget;

		let trainlineWidgetIframe = document.createElement('iframe');
		trainlineWidgetIframe.addEventListener('load', function() {
			trainlineWidget.classList.add('is-active');
		});
		trainlineWidgetIframe.src = trainlineWidgetSource;
		trainlineWidgetIframe.scrolling = 'no';
		trainlineWidgetIframe.allowFullscreen = true;
		trainlineWidget.appendChild(trainlineWidgetIframe);
	}
});